import { queryOptions, type UseQueryOptions } from '@tanstack/react-query';
import type {
  RecommendDuoCandidatesData,
  RecommendDuoCandidatesResponse,
} from 'generated/openapi';

import { PrivateApi } from '@/shared/api/httpClient';

const getRecommendedPlayersUrl: RecommendDuoCandidatesData['url'] =
  'duo/recommendations';

export const getRecommendedPlayersKey = () => ['recommendations'] as const;

export const getRecommendedPlayersOptions = <
  T = RecommendDuoCandidatesResponse['users'],
>(
  options?: Omit<
    UseQueryOptions<RecommendDuoCandidatesResponse['users'], unknown, T>,
    'queryKey' | 'queryFn'
  >,
) =>
  queryOptions<RecommendDuoCandidatesResponse['users'], unknown, T>({
    queryKey: getRecommendedPlayersKey(),
    queryFn: () =>
      PrivateApi.get(getRecommendedPlayersUrl)
        .json<RecommendDuoCandidatesResponse>()
        .then(res => res.users),
    ...options,
  });
